(function() {
  function formatMoney(cents) {
    var n = (cents / 100);
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function initSection(root) {
    if (root.dataset.ppInit === '1') return;
    root.dataset.ppInit = '1';

    // Stars
    root.querySelectorAll('[data-stars]').forEach(function(host) {
      var filled = parseFloat(host.getAttribute('data-stars')) || 0;
      var html = '';
      for (var i = 0; i < 5; i++) {
        var f = Math.max(0, Math.min(1, filled - i));
        var gid = 'pps-' + Math.random().toString(36).slice(2, 9);
        html += '<svg width="13" height="13" viewBox="0 0 24 24">' +
          '<defs><linearGradient id="' + gid + '" x1="0" x2="1" y1="0" y2="0">' +
            '<stop offset="' + (f * 100) + '%" stop-color="currentColor"/>' +
            '<stop offset="' + (f * 100) + '%" stop-color="rgba(0,0,0,0.12)"/>' +
          '</linearGradient></defs>' +
          '<path d="M12 2l2.9 6.2 6.6.7-5 4.6 1.4 6.5L12 16.8 6.1 20l1.4-6.5-5-4.6 6.6-.7L12 2z" fill="url(#' + gid + ')"/>' +
        '</svg>';
      }
      host.innerHTML = html;
    });

    // Gallery
    var heroImg = root.querySelector('[data-hero-img]');
    var heroCounter = root.querySelector('[data-hero-counter]');
    root.querySelectorAll('[data-thumbs] .thumb').forEach(function(btn) {
      btn.addEventListener('click', function() {
        root.querySelectorAll('[data-thumbs] .thumb').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (heroImg) heroImg.src = btn.getAttribute('data-src');
        if (heroCounter) heroCounter.textContent = (parseInt(btn.getAttribute('data-idx'), 10) + 1);
      });
    });

    var bundleAnchorSync = null;

    // Variant picker
    var variantInput = root.querySelector('[data-variant-input]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcSep = root.querySelector('[data-atc-sep]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var stickySub = root.querySelector('[data-sticky-sub]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyImg = root.querySelector('[data-sticky-img]');
    var qtyDisplay = root.querySelector('[data-qty-display]');
    var qtyInput = root.querySelector('[data-qty-input]');

    var currentUnitPriceRaw = 0;
    var firstActive = root.querySelector('.pp-variant-opt.active');
    if (firstActive) currentUnitPriceRaw = parseInt(firstActive.getAttribute('data-price-raw'), 10) || 0;
    if (!currentUnitPriceRaw) currentUnitPriceRaw = parseInt(root.getAttribute('data-unit-price'), 10) || 0;

    function refreshPrice() {
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      var totalFmt = formatMoney(currentUnitPriceRaw * qty);
      if (atcPrice) atcPrice.textContent = totalFmt;
      if (stickyPrice) stickyPrice.textContent = totalFmt;
    }

    root.querySelectorAll('.pp-variant-opt').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.hasAttribute('disabled')) return;
        root.querySelectorAll('.pp-variant-opt').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var vid = btn.getAttribute('data-variant-id');
        var raw = parseInt(btn.getAttribute('data-price-raw'), 10) || 0;
        var img = btn.getAttribute('data-image');
        currentUnitPriceRaw = raw;
        if (variantInput) variantInput.value = vid;
        if (heroImg && img) heroImg.src = img;
        if (stickyImg && img) stickyImg.src = img;
        var label = btn.querySelector('span');
        if (stickySub && label) stickySub.textContent = label.textContent;
        refreshPrice();
        if (bundleAnchorSync) bundleAnchorSync(vid, raw);
      });
    });

    // Qty stepper
    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      refreshPrice();
    }
    var minus = root.querySelector('[data-qty-minus]');
    if (minus) minus.addEventListener('click', function() { setQty(qty - 1); });
    var plus = root.querySelector('[data-qty-plus]');
    if (plus) plus.addEventListener('click', function() { setQty(qty + 1); });

    // Sticky ATC submits main form
    var atcForm = root.querySelector('[data-atc-form]');
    var stickyBtn = root.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn && atcForm) {
      stickyBtn.addEventListener('click', function() {
        if (typeof atcForm.requestSubmit === 'function') {
          atcForm.requestSubmit();
        } else {
          // Fallback for browsers without requestSubmit (older Safari): fire a
          // submit event so the async add-to-cart handler still runs.
          atcForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }

    // Async ATC via /cart/add.js — dispatches Horizon-compatible cart:update
    // event so the theme's cart drawer / icon bubble re-render automatically.
    // Falls back to native submit on any error.
    if (atcForm) {
      var ctaLabelText = (atcLabel && atcLabel.textContent) || 'In winkelwagen';
      var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
      atcForm.addEventListener('submit', function(e) {
        if (!window.fetch) return;
        e.preventDefault();
        var fd = new FormData(atcForm);
        // Ask Shopify to render the cart sections in the response so themes
        // (Horizon and similar) can swap in fresh HTML without an extra round-trip.
        fd.append('sections', 'cart-drawer,cart-icon-bubble,header');
        fd.append('sections_url', window.location.pathname);

        fetch(cartAddUrl + '.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        })
          .then(function(r) {
            return r.json().then(function(j) { return { ok: r.ok, body: j }; });
          })
          .then(function(res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || 'cart-add failed');
            return res.body;
          })
          .then(function(addResponse) {
            // Pull the latest cart resource so listeners get an accurate snapshot.
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(cart) { return { addResponse: addResponse, cart: cart }; });
          })
          .then(function(payload) {
            var addResponse = payload.addResponse;
            var cart = payload.cart;
            var added = addResponse.items && addResponse.items[0];
            var sections = addResponse.sections || {};

            // Horizon's cart drawer listens for 'cart:update' on document and
            // re-renders using detail.data.sections. This single event drives
            // both the cart icon bubble and the drawer.
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'pp-pdp-atc',
                data: {
                  source: 'product-form-component',
                  productId: added ? added.product_id : null,
                  itemCount: cart.item_count,
                  variantId: added ? added.variant_id : null,
                  sections: sections
                }
              }
            }));

            // Belt + braces: also fire the simpler aliases some themes listen for.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            // Visual feedback on the PDP itself.
            if (atcLabel) atcLabel.textContent = '✓ Toegevoegd';
            if (atcSep) atcSep.style.display = 'none';
            var toast = document.createElement('div');
            toast.className = 'pp-toast';
            toast.textContent = '🛍 Toegevoegd aan winkelwagen';
            document.body.appendChild(toast);

            setTimeout(function() {
              if (atcLabel) atcLabel.textContent = ctaLabelText;
              if (atcSep) atcSep.style.display = '';
              toast.remove();
            }, 2200);
          })
          .catch(function() { atcForm.submit(); });
      });
    }

    // Bundle
    var bundleStack = root.querySelector('[data-bundle-stack]');
    if (bundleStack) {
      var bundleItems = bundleStack.querySelectorAll('.pp-bundle-item');
      var totalEl = root.querySelector('[data-bundle-total]');
      var strikeEl = root.querySelector('[data-bundle-strike]');
      var msgEl = root.querySelector('[data-bundle-message]');
      function bundleTargetFor(anchorPrice) { return anchorPrice >= 1999 ? 2999 : 2499; }
      function syncBundle() {
        var subtotal = 0, count = 0, anchorPrice = 0;
        bundleItems.forEach(function(it) {
          if (!it.classList.contains('off')) {
            var p = parseInt(it.getAttribute('data-price'), 10) || 0;
            subtotal += p;
            count++;
            if (it.getAttribute('data-required') === '1') anchorPrice = p;
          }
        });
        // The bundle price only applies when all three products are selected,
        // matching the two automatic Buy-X-Get-Y discounts configured in Shopify.
        var allIn = bundleItems.length === 3 && count === 3;
        var total = allIn ? bundleTargetFor(anchorPrice) : subtotal;
        var savings = subtotal - total;
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (savings > 0) {
          if (strikeEl) { strikeEl.style.display = ''; strikeEl.textContent = formatMoney(subtotal); }
          if (msgEl) { msgEl.style.color = 'oklch(0.45 0.12 145)'; msgEl.textContent = 'Bespaart ' + formatMoney(savings) + ' · bundelprijs ' + formatMoney(total); }
        } else {
          if (strikeEl) strikeEl.style.display = 'none';
          if (msgEl) { msgEl.style.color = 'var(--ink-3)'; msgEl.textContent = 'Voeg alle items toe voor de bundelprijs'; }
        }
      }
      bundleAnchorSync = function(vid, priceCents) {
        var anchor = bundleStack.querySelector('.pp-bundle-item[data-required="1"]');
        if (anchor) {
          if (vid) anchor.setAttribute('data-variant-id', vid);
          if (priceCents) {
            anchor.setAttribute('data-price', priceCents);
            var pr = anchor.querySelector('.pr');
            if (pr) pr.textContent = formatMoney(priceCents);
          }
        }
        syncBundle();
      };
      bundleItems.forEach(function(it) {
        if (it.getAttribute('data-required') === '1') return;
        it.addEventListener('click', function() { it.classList.toggle('off'); syncBundle(); });
      });
      var activeVariantOpt = root.querySelector('.pp-variant-opt.active');
      if (activeVariantOpt) {
        bundleAnchorSync(activeVariantOpt.getAttribute('data-variant-id'), parseInt(activeVariantOpt.getAttribute('data-price-raw'), 10) || 0);
      } else {
        syncBundle();
      }

      var bundleAtc = root.querySelector('[data-bundle-atc]');
      if (bundleAtc) {
        var bundleAtcDefault = bundleAtc.innerHTML;
        bundleAtc.addEventListener('click', function() {
          if (bundleAtc.disabled) return;
          var items = [];
          bundleItems.forEach(function(it) {
            if (it.classList.contains('off')) return;
            var vid = it.getAttribute('data-variant-id');
            if (vid) items.push({ id: vid, quantity: 1 });
          });
          if (!items.length) return;
          if (!window.fetch) return;
          bundleAtc.disabled = true;
          var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble,header', sections_url: window.location.pathname })
          })
            .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, body: j }; }); })
            .then(function(res) {
              if (!res.ok) throw new Error((res.body && res.body.description) || 'bundle-add failed');
              return res.body;
            })
            .then(function(addResponse) {
              return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                  document.dispatchEvent(new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      sourceId: 'pp-pdp-bundle',
                      data: {
                        source: 'product-form-component',
                        itemCount: cart.item_count,
                        sections: addResponse.sections || {}
                      }
                    }
                  }));
                  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                  bundleAtc.innerHTML = '✓ Toegevoegd';
                  var toast = document.createElement('div');
                  toast.className = 'pp-toast';
                  toast.textContent = '🛍 Bundel toegevoegd aan winkelwagen';
                  document.body.appendChild(toast);
                  setTimeout(function() {
                    bundleAtc.innerHTML = bundleAtcDefault;
                    bundleAtc.disabled = false;
                    toast.remove();
                  }, 2200);
                });
            })
            .catch(function() { bundleAtc.disabled = false; window.location.href = '/cart'; });
        });
      }
    }

    // Tabs
    root.querySelectorAll('.pp-tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        root.querySelectorAll('.pp-tab-btn').forEach(function(b) { b.classList.remove('active'); });
        root.querySelectorAll('.pp-tab-panel').forEach(function(p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var t = btn.getAttribute('data-tab');
        var panel = root.querySelector('[data-panel="' + t + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    // FAQ
    root.querySelectorAll('.pp-faq-trigger').forEach(function(t) {
      t.addEventListener('click', function() { t.parentElement.classList.toggle('open'); });
    });

    // Inline play on video cards — native <video> or TikTok embed
    function extractTikTokId(url) {
      if (!url) return null;
      var m = url.match(/\/video\/(\d{6,})/);
      if (m) return m[1];
      m = url.match(/tiktok\.com\/(?:embed\/v2\/|@[^/]+\/video\/)(\d{6,})/);
      return m ? m[1] : null;
    }
    root.querySelectorAll('.pp-vc-card').forEach(function(card) {
      var videoSrc = card.getAttribute('data-video-src');
      var tiktokUrl = card.getAttribute('data-tiktok-url');
      // Uploaded video has priority over TikTok URL
      var tiktokId = videoSrc ? null : extractTikTokId(tiktokUrl);
      if (!videoSrc && !tiktokId) return; // no playable source — leave as static thumbnail
      var thumb = card.querySelector('.pp-vc-thumb');
      if (!thumb) return;
      card.classList.add('has-video');
      card.addEventListener('click', function(e) {
        if (card.classList.contains('playing')) return;
        if (e.target.closest('.pp-vc-close')) return;
        var player;
        if (videoSrc) {
          // Native <video> for uploaded videos
          player = document.createElement('video');
          player.src = videoSrc;
          player.controls = true;
          player.autoplay = true;
          player.playsInline = true;
          player.setAttribute('playsinline', '');
          player.className = 'pp-vc-video';
        } else {
          // TikTok embed iframe
          player = document.createElement('iframe');
          player.src = 'https://www.tiktok.com/embed/v2/' + tiktokId + '?autoplay=1';
          player.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
          player.setAttribute('allowfullscreen', 'true');
          player.className = 'pp-vc-iframe';
        }
        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'pp-vc-close';
        closeBtn.setAttribute('aria-label', 'Sluiten');
        closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        closeBtn.addEventListener('click', function(ev) {
          ev.stopPropagation();
          card.classList.remove('playing');
          player.remove();
          closeBtn.remove();
        });
        thumb.parentNode.appendChild(player);
        thumb.parentNode.appendChild(closeBtn);
        card.classList.add('playing');
      });
    });

    // Video carousel
    var vc = root.querySelector('[data-vc]');
    if (vc) {
      var track = vc.querySelector('[data-vc-track]');
      var total = parseInt(track.getAttribute('data-vc-total'), 10) || 0;
      var visible = 4;
      var max = Math.max(0, total - visible);
      var idx = 0;
      var prev = vc.querySelector('[data-vc-prev]');
      var next = vc.querySelector('[data-vc-next]');
      var counter = vc.querySelector('[data-vc-counter]');
      function vcSync() {
        track.style.transform = 'translateX(calc(' + (-idx) + ' * (((100% - 48px) / 4) + 16px)))';
        if (prev) prev.toggleAttribute('disabled', idx === 0);
        if (next) next.toggleAttribute('disabled', idx === max);
        if (counter) counter.textContent = (idx + 1) + '–' + Math.min(idx + visible, total) + ' / ' + total;
        vc.querySelectorAll('[data-vc-dots] .pp-vc-dot').forEach(function(d, i) { d.classList.toggle('active', i === idx); });
      }
      if (prev) prev.addEventListener('click', function() { idx = Math.max(0, idx - 1); vcSync(); });
      if (next) next.addEventListener('click', function() { idx = Math.min(max, idx + 1); vcSync(); });
      vc.querySelectorAll('[data-vc-dots] .pp-vc-dot').forEach(function(d) {
        d.addEventListener('click', function() { idx = parseInt(d.getAttribute('data-idx'), 10) || 0; vcSync(); });
      });
    }

    // Sticky ATC reveal
    var sticky = root.querySelector('[data-sticky-atc]');
    if (sticky) {
      window.addEventListener('scroll', function() {
        sticky.classList.toggle('visible', window.scrollY > 700);
      }, { passive: true });
    }

    // Product recommendations (customers also bought) — async via Shopify's
    // recommendations API (intent=related). Renders the pp-pdp-recommendations
    // section and injects it. Stays empty/hidden if nothing is returned.
    var recoMount = root.querySelector('[data-pp-reco]');
    if (recoMount && window.fetch) {
      var recoPid = recoMount.getAttribute('data-product-id');
      var recoUrl = recoMount.getAttribute('data-reco-url') || '/recommendations/products';
      if (recoPid) {
        fetch(recoUrl + '?section_id=pp-pdp-recommendations&intent=related&limit=4&product_id=' + encodeURIComponent(recoPid), { headers: { 'Accept': 'text/html' } })
          .then(function(r) { return r.ok ? r.text() : ''; })
          .then(function(html) { if (html && html.trim()) recoMount.innerHTML = html; })
          .catch(function() {});
      }
    }

    // Product-card actions (related + recommendations, incl. async-injected
    // cards) via event delegation: quick add-to-cart and wishlist toggle.
    root.addEventListener('click', function(e) {
      var heart = e.target.closest('.pp-card-heart');
      if (heart && root.contains(heart)) { e.preventDefault(); heart.classList.toggle('filled'); return; }

      var addBtn = e.target.closest('.pp-card-add');
      if (!addBtn || !root.contains(addBtn) || addBtn.disabled) return;
      e.preventDefault();
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid || !window.fetch) return;
      var addBtnDefault = addBtn.innerHTML;
      addBtn.disabled = true;
      var cardCartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
      fetch(cardCartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble,header', sections_url: window.location.pathname })
      })
        .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, body: j }; }); })
        .then(function(res) { if (!res.ok) throw new Error('card-add failed'); return res.body; })
        .then(function(addResponse) {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'pp-pdp-card', data: { source: 'product-form-component', itemCount: cart.item_count, sections: addResponse.sections || {} } }
              }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              addBtn.classList.remove('pp-btn-primary');
              addBtn.classList.add('pp-btn-secondary');
              addBtn.innerHTML = '✓ Toegevoegd';
              setTimeout(function() {
                addBtn.innerHTML = addBtnDefault;
                addBtn.classList.remove('pp-btn-secondary');
                addBtn.classList.add('pp-btn-primary');
                addBtn.disabled = false;
              }, 2000);
            });
        })
        .catch(function() { addBtn.disabled = false; });
    });
  }

  function initAll() {
    document.querySelectorAll('.pp-pdp').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when theme editor inserts new sections
  document.addEventListener('shopify:section:load', initAll);
})();
